"use client";

import { NuqsAdapter } from "nuqs/adapters/next/app";
import { SWRConfig } from "swr";

import { ModalStackProvider } from "@ala/core/components/modal";
import { ToastProvider } from "@ala/core/components/toast";
import { HistoryTracker } from "@ala/core/history/history-tracker";
import { TransitionRouter } from "@ala/core/transition-router";
import { fetcher } from "@ala/core/utils/fetcher";

import { TenantProviderWithRedirect } from "./tenant-provider-with-redirect";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <NuqsAdapter>
      <SWRConfig value={{ fetcher, revalidateOnFocus: false }}>
        <TenantProviderWithRedirect>
          <HistoryTracker />
          <TransitionRouter>
            <ToastProvider>
              <ModalStackProvider>{children}</ModalStackProvider>
            </ToastProvider>
          </TransitionRouter>
        </TenantProviderWithRedirect>
      </SWRConfig>
    </NuqsAdapter>
  );
};
